import InputTypeAhead from './InputTypeAhead';
export default InputTypeAhead;